import { StageBeneficiary } from 'BreetComponents';
import { useFormStage } from 'BreetHooks';

import ModalParts from '../ModalParts';
import { type MANAGEAUTOSETTLEMENTACCOUNT, requestPaymentStageTitle } from './DialogManageAutoSettlementAccount.helpers';
import FormComponent from './FormComponents';

export const DialogManageAutoSettlementAccount = () => {
	const formStage = useFormStage<MANAGEAUTOSETTLEMENTACCOUNT>(
		'auto-settlement',
		['auto-settlement', 'add-beneficiary', 'manage-beneficiaries'],
		requestPaymentStageTitle
	);

	const { navigator, isStageInactive } = formStage;

	return (
		<StageBeneficiary
			formStage={formStage}
			beneficiaryStage='add-beneficiary'
			manageBeneficaryStage='manage-beneficiaries'
			rootStage='auto-settlement'
			stageTitleObj={requestPaymentStageTitle}
		>
			<ModalParts.Stage hide={isStageInactive('auto-settlement')}>
				<FormComponent
					onAddNewBeneficiary={navigator.goTo('add-beneficiary')}
					onManageBeneficiaries={navigator.goTo('manage-beneficiaries')}
				/>
			</ModalParts.Stage>
		</StageBeneficiary>
	);
};
